import Utils from '../utils/Utils';
import NumericStepper from './NumericStepper';
import StateButton from './StateButton';
import Config from '../utils/Config';
import BonusPanel from './BonusPanel';
import LocaleManager from '../utils/LocaleManager';

export default class ControlPanel extends Phaser.Group {
    constructor(game, {
        availableStakes, stake,
        availableAutoSpins, autoSpins
    })
    {
        super(game);

        this.onAction = new Phaser.Signal();

        const stakeStepper = this._stakeStepper = new NumericStepper(game, {
            availableValues: availableStakes,
            value: stake,
            label: LocaleManager.getString('bet').toLocaleUpperCase(),
            formatFunction: (value) => Utils.formatMoney(value * Config.NUMBER_OF_LINES),
            bgImage: 'panels.more-less-bg-long'
        });
        stakeStepper.onChange.add((stepper, value) =>
        {
            this.onAction.dispatch(this, 'bet', value);
            stakeStepper.adjustValueText().then((fontSize) =>
            {
                this._autospinsStepper.setValueFontSize(fontSize);
            });
        });

        const autospinsStepper = this._autospinsStepper = new NumericStepper(game, {
            availableValues: availableAutoSpins,
            value: autoSpins,
            label: LocaleManager.getString('autoplay'),
            formatFunction: (value) => '' + Math.floor(value)
        });
        autospinsStepper.onChange.add((stepper, value) =>
        {
            this.onAction.dispatch(this, 'autospins', value);
        });
        stakeStepper.adjustValueText().then((fontSize) =>
        {
            this._autospinsStepper.setValueFontSize(fontSize);
        });

        const playButton = this._playButton = new StateButton(game, 0, 0, 'buttons.play', this._onClickPlay, this);
        playButton.anchor.set(0.5);
        playButton.hitArea.x -= playButton.width >> 1;
        playButton.hitArea.y -= playButton.height >> 1;
        this.addChild(playButton);

        const pauseButton = this._pauseButton = new StateButton(game, 0, 0, 'buttons.pause', this._onClickPause, this);
        pauseButton.anchor.set(0.5);
        pauseButton.hitArea.x -= pauseButton.width >> 1;
        pauseButton.hitArea.y -= pauseButton.height >> 1;
        this.addChild(pauseButton);

        stakeStepper.position.set(
            (-playButton.width >> 1) - stakeStepper.width,
            (-stakeStepper.height >> 1) + 2
        );
        this.addChild(stakeStepper);

        autospinsStepper.position.set(
            (playButton.width >> 1),
            (-autospinsStepper.height >> 1) + 2
        );
        this.addChild(autospinsStepper);

        pauseButton.visible = false;
        pauseButton.position.set(playButton.x, playButton.y);
        this.addChild(pauseButton);

        const bonusWinPanel = this._bonusWinPanel = new BonusPanel(game, {
            value: 0,
            label: LocaleManager.getString('bonus_win').toLocaleUpperCase(),
            formatFunction: (value) => Utils.formatMoney(value)
        });
        bonusWinPanel.position.set(stakeStepper.x - 14, stakeStepper.y - 12);
        this.addChild(bonusWinPanel);

        const bonusSpinsPanel = this._bonusSpinsPanel = new BonusPanel(game, {
            value: 0,
            label: LocaleManager.getString('free_spins').toLocaleUpperCase(),
            formatFunction: (value) => '' + value
        });
        bonusSpinsPanel.position.set(autospinsStepper.x - 8, bonusWinPanel.y);
        this.addChild(bonusSpinsPanel);

        this.showBonusPanels(false);

        this.unlock();
    }

    set autoSpins(value)
    {
        this._autospinsStepper.value = value;
    }

    enablePlayButton()
    {
        this._playButton.enabled = true;
        this._playButton.visible = true;
        this._pauseButton.visible = !this._playButton.visible;
    }

    enablePauseButton()
    {
        this._pauseButton.enabled = true;
        this._pauseButton.visible = true;
        this._playButton.visible = !this._pauseButton.visible;
    }

    lock(canPause = false)
    {
        this._playButton.visible = !canPause;
        this._pauseButton.visible = !this._playButton.visible;

        this._playButton.enabled = false;
        this._pauseButton.enabled = canPause;
        this._stakeStepper.enabled = false;
        this._autospinsStepper.enabled = false;
    }

    unlock(hasAutospins)
    {
        this._playButton.visible = true;
        this._pauseButton.visible = !this._playButton.visible;

        this._playButton.enabled = true;
        this._pauseButton.enabled = true;
        this._stakeStepper.enabled = !hasAutospins;
        this._autospinsStepper.enabled = !hasAutospins;
    }

    _onClickPlay()
    {
        this.onAction.dispatch(this, 'play');
    }

    _onClickPause()
    {
        this._playButton.visible = true;
        this._pauseButton.visible = !this._playButton.visible;
        this.onAction.dispatch(this, 'pause');
    }

    showBonusPanels(value)
    {
        this._bonusWinPanel.visible = value;
        this._bonusSpinsPanel.visible = value;
        this._stakeStepper.visible = !value;
        this._autospinsStepper.visible = !value;

        if (!value)
        {
            this._bonusWinPanel.value = 0;
            this._bonusSpinsPanel.value = 0;
        }
    }

    set bonusWin(value)
    {
        this._bonusWinPanel.value = value;
    }

    set bonusSpins(value)
    {
        this._bonusSpinsPanel.value = value;
    }
}
